import {makeStyles } from '@material-ui/core/styles';
import bg from "../assets/images/bg_small.jpg";

export const useStyles = makeStyles(theme => ({
    social_container: {
      width: '100%',
      height: 'auto',
      margin: '0 auto',
      backgroundColor: theme.palette.yellow,
      padding: '4.438rem 0 5rem 0'
    },
    social_grid_container: {
      width: '100%',
      maxWidth: '83.3125rem',
      padding: '2.0625rem',
      margin: '0 auto',
      display: 'flex',
      flexDirection: 'row'
    },
    social_heading:{
        width: '100%',
        height: 'auto',
        fontSize: '3.75rem',
        color: theme.palette.purple,
        textAlign: 'center',
        margin: '0 0 1.75rem 0',
    },
    left_container_bg:{
        position: 'relative',
        display: 'flex',
        height: '24rem',
        width: '100%',
        maxWidth: '32.5rem',
        margin: '0 auto 1rem auto',
        clipPath: 'polygon(0 0%, 0% 100%, 101% 100%, 101% 10%)',
        backgroundSize: 'cover',
        backgroundColor: theme.palette.purple,
        [theme.breakpoints.up(theme.breakpoints.values.md)]:{
            maxWidth: 'unset',
            width: '32.5rem',
            height: '25rem',
            margin: '0 0 1rem 12%',
        },
        [theme.breakpoints.up(theme.breakpoints.values.lg)]:{
            width: '100%',
            margin: '0',
        }
    },
    left_container:{
        '&:hover':{
            cursor: 'pointer'
        },
        overflow: 'hidden',
        position: 'relative',
        height: 'calc(100% - 2rem)',
        width: 'calc(100% - 2rem)',
        margin : '1rem 0 0 1rem',
        clipPath: 'polygon(0 0%, 0% 100%, 101% 100%, 101% 10%)',
        backgroundSize: 'cover',
        backgroundColor: '#333',
    },
    right_container:{
        position: 'relative',
        height: '24rem',
        width: '100%',
        maxWidth: '32.5rem',
        margin: '0 auto',
        clipPath: 'polygon(0 0%, 0% 95%, 100% 100%, 100% 0%)',
        backgroundColor: theme.palette.purple,
        backgroundImage:  `url(${bg})`,
        backgroundBlendMode: 'multiply',
        backgroundSize: 'cover',
        [theme.breakpoints.up(theme.breakpoints.values.md)]:{
            maxWidth: 'unset',
            clipPath: 'polygon(0 0%, 0% 92%, 100% 100%, 100% 0%)',
            width: '32.5rem',
            height: '25rem',
            margin: '0 12% 0 0',
            float: 'right',
        },
        [theme.breakpoints.up(theme.breakpoints.values.lg)]:{
            width: '100%',
            margin: '0',
        }
    },
    icon_container:{
        position: 'absolute',
        top: '0.938rem',
        left: '0.625rem',
        padding: '0.375rem',
        backgroundColor: theme.palette.purple,
        borderRadius: '15%'

    },
    right_grid_icon:{
        display: 'none',
        top: '0.625rem',
        left: 'unset',
        right: '0.625rem',
        [theme.breakpoints.up(theme.breakpoints.values.md)]:{
            display: 'unset'
        }
    },
    unset_icon:{
        position: 'relative',
        top: 'unset',
        left: 'unset',
        margin: '0 0 1rem 0',
        [theme.breakpoints.up(theme.breakpoints.values.md)]:{
            display: 'none'
        }
    },
    social_icon:{
        display: 'block',
        height: '2.5rem',
        width: '2.5rem',
        color: theme.palette.white,
    },
    social_details_container:{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '2.5% 0 0 4.3%',
        width: '41%',
        height: '64%',
        [theme.breakpoints.up(theme.breakpoints.values.md)]:{
            width: '41%',
            height: '100%',
            margin: '0 0 0 3.1%',
            minWidth: '13.375rem'
        },
        [theme.breakpoints.up(theme.breakpoints.values.lg)]:{
            width: '42%',
        }
    },
    social_details_heading:{
        width: '100%',
        height: 'auto',
        fontSize: '1.875rem',
        color: theme.palette.yellow,
        textAlign: 'center',
        margin: '0 0 1rem 0',
        [theme.breakpoints.up(theme.breakpoints.values.md)]:{
            fontSize: '2.5rem',
            margin: '0 0 0.625rem 0',
        },
        [theme.breakpoints.up(theme.breakpoints.values.xl)]:{
            fontSize: '3.75rem',
            margin: '0 0 0.625rem 0',
        }
    },
    social_details_p:{
        width: '100%',
        height: 'auto',
        fontSize: '1.125rem',
        color: theme.palette.white,
        textAlign: 'center',
        [theme.breakpoints.up(theme.breakpoints.values.md)]:{
            fontSize: '1.5rem',
            margin: '0 0 1.5rem 0',
        },
        [theme.breakpoints.up(theme.breakpoints.values.xl)]:{
            fontSize: '2rem',
            margin: '0 0 1rem 0',
        }
    },
    social_image:{
        height: '12.938rem',
        margin: '0.625rem 1rem 0 10.2%',
        filter: `drop-shadow(0rem 0rem 1rem ${theme.palette.black})`,
        [theme.breakpoints.up(theme.breakpoints.values.md)]:{
            height: '78%',
            margin: '7.5% 0 0 10.5%'
        },
        [theme.breakpoints.up(theme.breakpoints.values.lg)]:{
            height: '76.6%',
            margin: '6% 0 0 9%'
        },
        [theme.breakpoints.up(theme.breakpoints.values.xl)]:{
            height: '90%',
            margin: '2% 0 0 10%'
        }
    },
    button_container:{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    right_content:{
        display: 'flex',
        width: '100%',
        height: 'auto',
        [theme.breakpoints.up(theme.breakpoints.values.md)]:{
            height: '100%',
        }
    },
    thumb:{
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translateY(-50%) translateX(-50%)',
        height: '100%',
        [theme.breakpoints.up(theme.breakpoints.values.xl)]:{
            width: '100%',
            height: 'auto',
        }
    },
    play_div:{
        width: 'fit-content',
        height: 'fit-content',
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translateY(-50%) translateX(-50%)',
    },
    play_svg:{
        display: 'block',
        height: '5.75rem',
        width: '5.75rem',
        color: theme.palette.white,
    },
}));
